import {Component, Inject, Input, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {
  SearchState,
  SearchStateService,
} from '../_core/services/search-state-v2.service';
import { omitBy, isNull } from 'lodash-es';
import { SearchService } from '../_core/services/search.service';
import { Router } from '@angular/router';
import { Subject, Subscription, forkJoin, takeUntil } from 'rxjs';
import { LoadingSpinnerService } from '../_core/services/loading-spinner.service';
import { CURRENT_TENNANT } from '../app.component';
import {
  ActionPasser,
  Dropdown,
  ErrorMessages,
  GMList,
  Grandmaster,
  Validator,
  Logger,
  BahamutHelper,
  Checkbox
} from 'lo-bahamut';
import { CareFindrTenantConfigurationService } from '../_core/apiV2/services/care-findr-tenant-configuration.service';
import {level} from "lo-bahamut-v1/types";
import {HandlebarsService} from "../_core/services/handlebars.service";
import {ProviderSearchService} from "../_core/apiV2/services/provider-search.service";
import {Title} from "@angular/platform-browser"
import {SearchResultService} from "../services/search-result.service";
import * as Handlebars from "handlebars"
import {DOCUMENT} from "@angular/common";
import {
  applyPcpSpecialtySelection,
  getActiveVisibleEnabledRef,
  getRefsByJsonId,
} from "../_core/services/pcp-specialty-utils";
import { DefaultLocationService } from "../_core/services/default-location.service";

export type option = {
  value: string;
  description: string;
};

@Component({
  selector: 'app-search-start-v2',
  templateUrl: './search-start-v2.component.html',
  styleUrls: ['./search-start-v2.component.scss']
})

export class SearchStartV2Component implements OnInit, OnDestroy {
  // private url: string = "../../assets/search-page.hbs";
  // private url: string = "../../assets/search-page-champion.hbs";
  // private url: string = "../../assets/search-page-riverspring.hbs";
  private url: string = "../../assets/search-page-champion.hbs";
  private _data: any;
  private subscriptionData!: Subscription;
  isPlanDropDownEnabled = true;
  isPlanStateDropdownEnabled = CURRENT_TENNANT === "champion" ? true : false;
  isProviderNetworkDropdownEnabled = CURRENT_TENNANT === "champion" ? true : false;
  isSpecialityHeaderNeedToChange = false;
  planOptions: option[] = [];
  specialtyOptions: level[] = [];
  debounceDelay = 300;
  destroyed$ = new Subject<void>();

  searchState: SearchState = {
    Query: {
      sortBy: 'distance-asc',
    },
    Extra: {},
  };

  printState: SearchState = {
    Query: {},
    Extra: {},
  };

  // page title
  defaultTitle: string = '';
  @Input() isNLSearchEnabled: boolean | undefined = false;


  public get data(): any { return this._data; }
  @ViewChild('gm') gm: Grandmaster;

  private readonly villageCarePlanClassMap: Record<string, string> = {
    'villagecaremax-managed-long-term-care-mltc': 'villagecare-mltc',
    'villagecaremax-medicare-total-advantage-plan-map': 'villagecare-mtap',
    'villagecaremax-medicare-health-advantage-plan-dsnp': 'villagecare-mhap',
    'villagecaremax-medicare-select-advantage-plan-hmo': 'villagecare-msap',
  };

  private readonly villageCarePlanClasses: string[] = Object.values(this.villageCarePlanClassMap);

  constructor(private searchService: SearchService,
              public actionPasser: ActionPasser,
              public gmList: GMList,
              private loadingSpinnerService: LoadingSpinnerService,
              public logger: Logger,
              private lobhelper: BahamutHelper,
              public errorMessages: ErrorMessages,
              public grandmaster: Grandmaster,
              public validator: Validator,
              private hbs: HandlebarsService,
              private searchStateService: SearchStateService,
              private tenantConfigService: CareFindrTenantConfigurationService,
              private providerSearchService: ProviderSearchService,
              private router: Router,
              private titleService: Title,
              private renderer: Renderer2,
              private defaultLocationService: DefaultLocationService,
              @Inject(DOCUMENT) private document: Document
  ) {
  }
  async ngOnInit() {
    this.defaultTitle = this.titleService.getTitle();
    const homeTranslations: any = {
      en: "Home",
      es: "Página de inicio",
      ru: "Главная страница",
      ht: "Paj prensipal",
      zh: "主页"
    };
    const selectedLang = localStorage.getItem('translateLanguageTo') || 'en';
    const translatedHome = homeTranslations[selectedLang] || homeTranslations['en'];
    const newTitle = `CareFinDr: ${translatedHome}`;
    this.titleService.setTitle(newTitle);
    this.document.documentElement.lang = localStorage.getItem('translateLanguageTo') || 'en';
    // Trigger screen reader announcement
    setTimeout(() => {
      const liveRegion = document.getElementById('page-title-announcer');
      if (liveRegion) {
        liveRegion.textContent = newTitle;
      }
    }, 0);
    this.loadingSpinnerService.showLoader();
    await this.seedDefaultVillageCareLocation();
    const tenantComponentJs$ = this.tenantConfigService.getTenantBluePrint({page_name: `${CURRENT_TENNANT}-start-page`, tenant: CURRENT_TENNANT, 'Accept-Language': localStorage.getItem('translateLanguageTo') || 'en'});
    // const tenantComponentJs$ = this.providerSearchService.multiTenantProviderDetailCareFindr({uid: "NPI:1952543647", "x-tenant-id": 'riverspring'});

    // this.getDataSourceTemplateJson();
    forkJoin([tenantComponentJs$])
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: ([componentJsResponse]) => {
          if(localStorage.getItem('largeText') && (localStorage.getItem('largeText') === 'true')){
            const body = document.body;
            this.renderer.addClass(body, 'text-large');
          }
          let response: any = {};
          // Try decoding if needed
          if (typeof componentJsResponse === 'string') {
            try {
              // First decode base64 with UTF-8 support, then parse JSON
              const decodedStr = decodeURIComponent(atob(componentJsResponse).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
              }).join(''));
              const compiledTemplate = Handlebars.compile(decodedStr);
              const rendered = compiledTemplate({
                locationText: this.searchStateService.getSearchCriteria().Extra.locationText ?? '',
              });
              response = JSON.parse(rendered);
            } catch (e) {
              // If the string is not encoded, fallback to direct parsing
              try {
                response = JSON.parse(componentJsResponse);
              } catch (err) {
                console.error('Failed to decode/parse response:', componentJsResponse, err);
                // Handle error as needed, e.g., set a default error object
                response = {};
              }
            }
          } else {
            response = componentJsResponse;
          }
          // Now assign parsed data as usual
          this._data = response.componentsConfig;
          this.errorMessages.defaultErrorMessages = response.errorMessages;
          console.log(this._data); // NOTE: use this._data not this.data for consistency

          /**
           * Set the initial aria-pressed state for language buttons based on user preference.
           * After a 200ms delay (allowing DOM elements to render), this retrieves the previously
           * selected language from localStorage and marks the corresponding button as active
           * by setting its aria-pressed attribute to 'true'. If no preference is stored,
           * defaults to English.
           */
          setTimeout(()=>{
            let langResizeContainerUk = this.lobhelper.getDesiredChildUK('1', "careFindrLangResizeContainer");
            let clickedlangBtnUk
            if(localStorage.getItem('preferredLanguage')){
              let btnId = localStorage.getItem('preferredLanguage')
              if (btnId != null) {
                clickedlangBtnUk = this.lobhelper.getDesiredChildUK(langResizeContainerUk, btnId);
              }
              const btnEl: any = this.gmList.gmList[clickedlangBtnUk]?.elementRef;
              btnEl.setAttribute('aria-pressed', 'true');
            }else{
              clickedlangBtnUk = this.lobhelper.getDesiredChildUK(langResizeContainerUk, 'preferredLanguageEnglish')
              const btnEl: any = this.gmList.gmList[clickedlangBtnUk]?.elementRef;
              btnEl.setAttribute('aria-pressed', 'true');
            }
          }, 200)
        },
        error: (err) => {
          if (err.status === 403) {
            console.error('You are not authorized to view this', err);
            this.router.navigate(['error-handler'], {state: { msg:"Access denied"}});
          } else {
            console.error('Please try again later or contact support.', err);
          }
        },
        complete: () => {
          this.loadingSpinnerService.hideLoader();
        }
      });


    this.actionPasser.groupEmitter$.pipe(takeUntil(this.destroyed$)).subscribe((group: any) => {
      // console.log(group)
      if (group !== undefined && Object.keys(group).length !== 0) {
        switch (group[0].groupName) {
          case "setupInitialScreen":
            break;
          case "handleInputChange":
            this.handleInputChange(group);
            break;
          case "enableDisableIPA":
            this.enableDisableIPA(group);
            break;
          case "handlePlanChange":
            this.handlePlanChange(group);
            break;
          case "checkedPreciseLocation":
            this.checkedPreciseLocation(group);
            break;
          case "checkedPCP":
            this.checkedPCP(group);
            break;
          case "showInfoModal":
            const innerContainerUKShow = this.lobhelper.getDesiredChildUK("1", "careFindrSearchPageInnerContainer");
            const infoModalUKShow = this.lobhelper.getDesiredChildUK(innerContainerUKShow, "infoModal");
            const infoModalShow = infoModalUKShow && this.gmList.gmList[infoModalUKShow];
            if (infoModalShow && infoModalShow.reference) {
              // Ensure Angular sees the state change, especially if closed via backdrop
              infoModalShow.reference.hide = true;
              if (infoModalShow.inputs) infoModalShow.inputs.hide = true;
              setTimeout(() => {
                infoModalShow.reference.hide = false;
                if (infoModalShow.inputs) infoModalShow.inputs.hide = false;
              }, 250);
            }
            break;
          case "hideInfoModal":
            const innerContainerUKHide = this.lobhelper.getDesiredChildUK("1", "careFindrSearchPageInnerContainer");
            const infoModalUKHide = this.lobhelper.getDesiredChildUK(innerContainerUKHide, "infoModal");
            const infoModalHide = infoModalUKHide && this.gmList.gmList[infoModalUKHide];
            if (infoModalHide && infoModalHide.reference) {
              infoModalHide.reference.hide = true;
              if (infoModalHide.inputs) infoModalHide.inputs.hide = true;
            }
            break;
          case "clearFormData":
            if(this.isPlanDropDownEnabled) {
              ['planDropdown', 'planDropdown2'].forEach((dropdownId) => {
                const planDropdownUK = this.lobhelper.getDesiredChildUK(group[1]?.uniqueKey, dropdownId);
                const planDropdown = planDropdownUK && this.gmList.gmList[planDropdownUK];
                if (planDropdown && planDropdown.reference) {
                  const planDropdownRef = planDropdown.reference;
                  planDropdownRef.data = [];
                  if (typeof planDropdownRef.clearErrorMessage === 'function') {
                    planDropdownRef.clearErrorMessage();
                  }
                }
              });
            }
            if(this.isPlanStateDropdownEnabled) {
              const planStateDropdownUK = this.lobhelper.getDesiredChildUK(group[1]?.uniqueKey, "planStateDropdown");
              const planStateDropdown = planStateDropdownUK && this.gmList.gmList[planStateDropdownUK];
              if (planStateDropdown && planStateDropdown.reference) {
                planStateDropdown.reference.data = [];
              }
            }
            if(this.isProviderNetworkDropdownEnabled) {
              const providerNetworkDropdownUK = this.lobhelper.getDesiredChildUK(group[1]?.uniqueKey, "providerNetworkDropdown");
              const providerNetworkDropdown = providerNetworkDropdownUK && this.gmList.gmList[providerNetworkDropdownUK];
              if (providerNetworkDropdown && providerNetworkDropdown.reference) {
                providerNetworkDropdown.reference.data = [];
              }
            }

            let insideContainer1 = this.lobhelper.getDesiredChildUK(group[1].uniqueKey, "insideContainer1");
            let sliderContainer = this.lobhelper.getDesiredChildUK(insideContainer1, "sliderContainer");
            let insideContainer2 = this.lobhelper.getDesiredChildUK(group[1].uniqueKey, "insideContainer2");
            let locationDropdownUK = this.lobhelper.getDesiredChildUK(insideContainer1, "locationDropdown");
            let locationDropdownRef = this.gmList.gmList[locationDropdownUK].reference;
            locationDropdownRef.data = undefined;
            let preciseCheckboxContainerUk = this.lobhelper.getDesiredChildUK(sliderContainer, "preciseCheckboxContainer");
            let preciseLocationCheckbox = this.lobhelper.getDesiredChildUK(preciseCheckboxContainerUk, "preciseLocation");
            let preciseLocationCheckboxRef = this.gmList.gmList[preciseLocationCheckbox].reference;
            preciseLocationCheckboxRef.checked = false;
            let distanceDropdownUK = this.lobhelper.getDesiredChildUK(insideContainer1, "distanceDropdown");
            let distanceDropdownRef = this.gmList.gmList[distanceDropdownUK].reference;
            distanceDropdownRef.data = [];
            // Set default distance to 5 for villagecare tenant only
            if (CURRENT_TENNANT === 'villagecare') {
              distanceDropdownRef.data = ['5'];
            } else {
              distanceDropdownRef.data = ['25'];
            }

            let nameInputUK = this.lobhelper.getDesiredChildUK(insideContainer2, "nameInput");
            let nameInputRef = this.gmList.gmList[nameInputUK].reference;
            nameInputRef.data = "";

            let providerOrSpecialityDropdownUK = this.lobhelper.getDesiredChildUK(insideContainer2, "providerOrSpecialityDropdown");
            let providerOrSpecialityDropdownRef = this.gmList.gmList[providerOrSpecialityDropdownUK].reference;
            providerOrSpecialityDropdownRef.clearComponent();

            // Uncheck PCP checkbox in UI as part of clear action
            try {
              const pcpCheckboxContainerUK = this.lobhelper.getDesiredChildUK(insideContainer2, "pcpCheckboxContainer");
              const pcpCheckboxUK = this.lobhelper.getDesiredChildUK(pcpCheckboxContainerUK, "pcpCheckbox");
              const pcpCheckboxRef = this.gmList.gmList[pcpCheckboxUK]?.reference;
              if (pcpCheckboxRef) {
                pcpCheckboxRef.checked = false;
              }
            } catch (e) {
              // no-op: if structure not present for some tenants
            }

            // Clear searchState for all cleared fields
            this.searchState.Query.programType = CURRENT_TENNANT === 'champion' ? [] : undefined;
            this.searchState.Query.planState = undefined;
            this.searchState.Query.siteNumbers = undefined;
            this.searchState.Query.name = "";
            this.searchState.Query.specialtiesV2 = [];
            this.searchState.Query.location = undefined;
            this.searchState.Extra.locationText = undefined;
            this.searchState.Extra.locationSource = 'cleared';
            this.searchState.Query.isPreciseLocation = undefined;
            this.searchState.Query.isPCP = undefined;
            this.applyChampionPlanStateSelection(undefined, group[1]?.uniqueKey, false);

            // Clear Behavioral Health filters UI and state for all tenants
            try {
              const bhContainerUK = this.lobhelper.getDesiredChildUK(group[1].uniqueKey, 'behavioralHealthFiltersContainer');
              if (bhContainerUK) {
                const bhfRowUK = this.lobhelper.getDesiredChildUK(bhContainerUK, 'bhf_row');
                const bhfRow2UK = this.lobhelper.getDesiredChildUK(bhContainerUK, 'bhf_row2');

                // Clear each Behavioral Health dropdown by searching both rows, since tenants arrange them differently
                const bhFilterIds = ['filters_agegroup', 'filters_loc', 'filters_crisis', 'filters_affiliation', 'filters_conditions'];

                const clearById = (id: string) => {
                  try {
                    const ddUK = this.lobhelper.getDesiredChildUK(bhfRowUK, id) || this.lobhelper.getDesiredChildUK(bhfRow2UK, id);
                    const dd = ddUK && this.gmList.gmList[ddUK];
                    const ref: any = dd?.reference;
                    if (ref) {
                      if (typeof ref.clearComponent === 'function') {
                        ref.clearComponent();
                      } else {
                        if (Array.isArray(ref.data)) ref.data = [];
                        if (Array.isArray(ref.selected)) ref.selected = [];
                        if (Array.isArray(ref.checkboxes)) {
                          ref.checkboxes.forEach((cb: any) => cb.checked = false);
                        }
                      }
                    }
                  } catch { }
                };

                bhFilterIds.forEach(clearById);
              }

              // Clear corresponding state
              if (this.searchState.Extra && (this.searchState.Extra as any).behavioralHealthFilters) {
                (this.searchState.Extra as any).behavioralHealthFilters = undefined;
              }
            } catch { }
            this.searchStateService.updateSearchCriteria(this.searchState);

            break;
          case "submitFormData":
            const anythingInvalid2 = this.validator.checkIfAnythingInvalid(group[1].uniqueKey);
            if (anythingInvalid2) {
              return
            }
            this.handleSubmit(group);
            break;
          case "slider-dropdown-group": {
            var first = this.gmList.gmList[group[0].uniqueKey].reference;
            var second = this.gmList.gmList[group[1].uniqueKey].reference;
            if (first.data != second.data) {
              if (second.componentRef.componentType == Dropdown) {
                second.checkboxes.forEach((cb: Checkbox) => {
                  cb.checked = false;
                })
                second.data = [first.data];
              } else {
                second.data = first.data;
              }
            }
            break;
          }
          case "resetTextSize": {
            const body = document.body;
            if (body.classList.contains('text-large')) {
              this.renderer.removeClass(body, 'text-large');
            }
            localStorage.setItem('largeText', 'false');
            break;
          }
          case "largeTextSize": {
            const body = document.body;
            if (!body.classList.contains('text-large')) {
              this.renderer.addClass(body, 'text-large');
            }
            localStorage.setItem('largeText', 'true');
            break;
          }
          case "languageButton": {
            // Identify which language button was clicked
            const btnRef = this.gmList.gmList[group[0].uniqueKey].reference;
            const clickedId = btnRef?.jsonid || btnRef?.id || '';
            const selected = clickedId || 'preferredLanguageEnglish';
            const translateLanguageTo = group[0].passedInfo[0];

            // Store selection in localStorage
            localStorage.setItem('preferredLanguage', selected);
            localStorage.setItem('translateLanguageTo', translateLanguageTo);

            // Update UI to reflect selection
            try {
              setTimeout(() => this.applyPreferredLanguageUI(), 0);
            } catch {}
            window.location.reload();
            break;
          }
        }
      }
    });
  }

  handleInputChange(group: any) {
    let inputRef = this.gmList.gmList[group[0].uniqueKey].reference;

    if(this.searchState.Query.location?.distance == undefined){
      this.searchStateService.updateSearchCriteria({
        Query: {
          ...this.searchState.Query,
          location: {
            ...this.searchState.Query.location,
            distance: "25",
          },
        },
      });
    }
    if(inputRef.jsonid === "locationDropdown"){
      if (inputRef.data?.geometry) {
        this.searchState.Query.location = {
          latitude: inputRef.data.geometry.location.lat() as unknown as string,
          longitude: inputRef.data.geometry.location.lng() as unknown as string,
          distance: inputRef.data.toString() ?? '25',
        };
        this.searchState.Extra.locationText = inputRef.data.formatted_address;
        this.searchState.Extra.locationSource = 'user';
        this.searchState.Query.address = {
          ...(this.searchState.Query.address ?? {}),
          city: inputRef.data.cities,
          state: inputRef.data.state,
          postalCode: inputRef.data.postalCode,
        };
      } else {
        this.searchState.Query.location = this.searchState.Extra.locationText = undefined;
        this.searchState.Extra.locationSource = 'cleared';
      }
      this.searchStateService.updateSearchCriteria(this.searchState);
    } else if (inputRef.jsonid === "nameInput") {
      this.searchState.Query.name = inputRef.data;
      this.searchStateService.updateSearchCriteria(this.searchState);

    } else if (inputRef.jsonid === "providerOrSpecialityDropdown") {
      if(inputRef.data.length > 0){
        this.searchState.Query.specialtiesV2 = inputRef.data;
      } else {
        this.searchState.Query.specialtiesV2 = [];
      }
      this.searchStateService.updateSearchCriteria(this.searchState);
    }else if (inputRef.jsonid === "planDropdown" || (CURRENT_TENNANT === 'champion' && inputRef.jsonid === "planDropdown2") ) {
      if (CURRENT_TENNANT === 'villagecare') this.updateBodyClassBySelectedPlan(inputRef.data[0]);
      if(inputRef.data.length > 0 && inputRef.data[0] !== "") {
        this.searchState.Query.programType = inputRef.data;
        this.searchStateService.updateSearchCriteria(this.searchState);
        // Ensure any plan-related error is cleared once a valid plan is selected
        if (typeof inputRef.clearErrorMessage === 'function') {
          inputRef.clearErrorMessage();
        }
      } else {
        // For champion tenant, send empty array when no plan is selected; otherwise keep previous behavior
        if (CURRENT_TENNANT === 'champion') {
          this.searchState.Query.programType = [];
        } else {
          this.searchState.Query.programType = undefined;
        }
        if (CURRENT_TENNANT === 'villagecare' || CURRENT_TENNANT === 'riverspring' || CURRENT_TENNANT === 'elderservehealth') {
          const empty = !Array.isArray(inputRef.data) || inputRef.data.length === 0 || (inputRef.data.length === 1 && (!inputRef.data[0] || inputRef.data[0] === ''));
          if (empty) {
            setTimeout(() => {
              inputRef.setCustomErrorMessage('required');
              inputRef.cdRef.detectChanges();
            });
          } else if (!empty) {
            if (typeof inputRef.clearErrorMessage === 'function') {
              inputRef.clearErrorMessage();
            }
          }
        }
      }
      this.searchStateService.updateSearchCriteria(this.searchState);
    }else if (inputRef.jsonid === "planStateDropdown") {
      if(inputRef.data.length > 0 && inputRef.data[0] !== "") {
        this.searchState.Query.planState = inputRef.data;
      }else{
        this.searchState.Query.planState = undefined;
      }
      this.applyChampionPlanStateSelection(this.searchState.Query.planState, group[0]?.uniqueKey, true);
      this.searchStateService.updateSearchCriteria(this.searchState);
    }else if (inputRef.jsonid === "providerNetworkDropdown") {
      if(inputRef.data.length > 0 && inputRef.data[0] !== "") {
        this.searchState.Query.siteNumbers = inputRef.data;
      }else{
        this.searchState.Query.siteNumbers = undefined;
      }
      this.searchStateService.updateSearchCriteria(this.searchState);
    } else {
      if (CURRENT_TENNANT === "villagecare") {
        if (["providerOrSpecialityDropdown2", "providerOrSpecialityDropdown3", "providerOrSpecialityDropdown4"]
          .includes(inputRef.jsonid)) {
          if (inputRef.data.length > 0) {
            this.searchState.Query.specialtiesV2 = inputRef.data;
          } else {
            this.searchState.Query.specialtiesV2 = [];
          }
          this.searchStateService.updateSearchCriteria(this.searchState);
        }
      }

      // Behavioral Health Filters (Age Group, Affiliation, Level of Care, Crisis Services, Conditions Treated)
      if (["filters_agegroup", "filters_affiliation", "filters_loc", "filters_crisis", "filters_conditions"].includes(inputRef.jsonid)) {
        if (inputRef.jsonid === "filters_agegroup") {
          this.searchState.Query.ageGroup = Array.isArray(inputRef.data) ? inputRef.data : undefined;
        } else if (inputRef.jsonid === "filters_affiliation") {
          this.searchState.Query.affiliation = Array.isArray(inputRef.data) ? inputRef.data : undefined;
        } else if (inputRef.jsonid === "filters_loc") {
          this.searchState.Query.levelOfCare = Array.isArray(inputRef.data) ? inputRef.data : undefined;
        } else if (inputRef.jsonid === "filters_crisis") {
          this.searchState.Query.crisisServices = Array.isArray(inputRef.data) ? inputRef.data : undefined
        } else if (inputRef.jsonid === "filters_conditions") {
          this.searchState.Query.conditionsTreated = Array.isArray(inputRef.data) ? inputRef.data : undefined;
        }

        this.searchStateService.updateSearchCriteria(this.searchState);
      }
    }
    this.isSearchEnabled(group);
  }

  private updateBodyClassBySelectedPlan(planValue?: string): void {
    const body = this.document.body;
    if (!body) return;

    this.villageCarePlanClasses.forEach((className) => {
      this.renderer.removeClass(body, className);
    });

    if (!planValue) return;

    const mappedClass = this.villageCarePlanClassMap[planValue];
    if (mappedClass) {
      this.renderer.addClass(body, mappedClass);
    }
  }

  private applyChampionPlanStateSelection(planState: string[] | undefined, anchorUk?: string, selectAllActive = false): void {
    if (CURRENT_TENNANT !== 'champion') return;

    const containerUk = anchorUk
      ? this.lobhelper.getDesiredParentUK(anchorUk, 'SearchPageContainer') || anchorUk
      : this.lobhelper.getDesiredChildUK('1', 'SearchPageContainer');
    const planDropdownRef = this.getSearchPageChildRef(containerUk, 'planDropdown');
    const planDropdown2Ref = this.getSearchPageChildRef(containerUk, 'planDropdown2');
    const providerNetworkRef = this.getSearchPageChildRef(containerUk, 'providerNetworkDropdown');
    const selectedState = Array.isArray(planState) ? planState[0] : undefined;

    if (selectedState === 'CA') {
      this.setDropdownState(planDropdownRef, false, false);
      this.setDropdownState(planDropdown2Ref, true, true);
      this.searchState.Query.programType = selectAllActive
        ? this.selectAllDropdownOptions(planDropdownRef)
        : this.getDropdownValues(planDropdownRef);
      this.updateProviderNetworkState(providerNetworkRef, planDropdownRef);
    } else if (selectedState === 'NV') {
      this.setDropdownState(planDropdownRef, true, true);
      this.setDropdownState(planDropdown2Ref, false, false);
      this.searchState.Query.programType = selectAllActive
        ? this.selectAllDropdownOptions(planDropdown2Ref)
        : this.getDropdownValues(planDropdown2Ref);
      this.updateProviderNetworkState(providerNetworkRef, planDropdown2Ref);
    } else {
      this.setDropdownState(planDropdownRef, false, true);
      this.setDropdownState(planDropdown2Ref, true, true);
      this.clearDropdownSelection(planDropdownRef);
      this.clearDropdownSelection(planDropdown2Ref);
      this.updateProviderNetworkState(providerNetworkRef, undefined);
    }
  }

  private getSearchPageChildRef(containerUk: string | undefined, childId: string): any {
    if (!containerUk) return undefined;
    const childUk = this.lobhelper.getDesiredChildUK(containerUk, childId);
    const entry = childUk ? this.gmList.gmList[childUk] : undefined;
    if (entry?.reference && !Array.isArray(entry.reference.options)) {
      // Backend-generated option lists aren't always hydrated onto the component yet; fall back to the raw JSON config.
      entry.reference.__configOptions = (entry.json?.inputs as any)?.options;
    }
    return entry?.reference;
  }

  private setDropdownState(dropdownRef: any, hide: boolean, disabled: boolean): void {
    if (!dropdownRef) return;
    dropdownRef.hide = hide;
    dropdownRef.disabled = disabled;
    dropdownRef.cdRef?.detectChanges?.();
  }

  private getDropdownValues(dropdownRef: any): string[] {
    return Array.isArray(dropdownRef?.data)
      ? dropdownRef.data.filter((value: any) => typeof value === 'string' ? value.trim().length > 0 : !!value)
      : [];
  }

  private selectAllDropdownOptions(dropdownRef: any): string[] {
    if (!dropdownRef) return [];
    const options = Array.isArray(dropdownRef.options) ? dropdownRef.options : dropdownRef.__configOptions;
    if (!Array.isArray(options)) return [];
    const values = this.getDropdownValues({ data: options.map((option: any) => option?.value) });
    if (values.length === 0) return [];
    dropdownRef.data = values;
    if (Array.isArray(dropdownRef.selected)) dropdownRef.selected = [...values];
    if (Array.isArray(dropdownRef.checkboxes)) {
      dropdownRef.checkboxes.forEach((checkbox: any) => checkbox.checked = values.includes(checkbox.value));
    }
    dropdownRef.cdRef?.detectChanges?.();
    return values;
  }

  private clearDropdownSelection(dropdownRef: any): void {
    if (!dropdownRef) return;
    dropdownRef.data = [];
    if (Array.isArray(dropdownRef.selected)) dropdownRef.selected = [];
    if (Array.isArray(dropdownRef.checkboxes)) {
      dropdownRef.checkboxes.forEach((checkbox: any) => checkbox.checked = false);
    }
    dropdownRef.cdRef?.detectChanges?.();
  }

  private updateProviderNetworkState(providerNetworkRef: any, planRef: any): void {
    const hasPlanSelection = this.getDropdownValues(planRef).length > 0;
    if (providerNetworkRef) {
      providerNetworkRef.disabled = !hasPlanSelection;
      if (!hasPlanSelection) {
        providerNetworkRef.data = [];
        this.searchState.Query.siteNumbers = undefined;
      }
      providerNetworkRef.cdRef?.detectChanges?.();
    }
  }

  enableDisableIPA(group: any) {
    let planRef = this.gmList.gmList[group[0].uniqueKey].reference;
    let providerNetworkRef = this.gmList.gmList[group[1].uniqueKey].reference;
    if (
      Array.isArray(planRef.data) &&
      planRef.data.length > 0 &&
      !(planRef.data.length === 1 && planRef.data[0] === '')
    ) {
      providerNetworkRef.disabled = false;
    }else{
      providerNetworkRef.disabled = true;
      providerNetworkRef.data = [];
      this.searchState.Query.siteNumbers = undefined;
      this.searchStateService.updateSearchCriteria(this.searchState);
    }
  }

  handlePlanChange(group: any) {
    let planRef = this.gmList.gmList[group[0].uniqueKey].reference;//the emitted element is the plan dropdown default to 0th index
    let specialtyRef1 = this.gmList.gmList[group[1].uniqueKey].reference;
    let specialtyRef2 = this.gmList.gmList[group[2].uniqueKey].reference;
    let specialtyRef3 = this.gmList.gmList[group[3].uniqueKey].reference;
    let specialtyRef4 = this.gmList.gmList[group[4].uniqueKey].reference;

    let soecialtyParentUk = this.lobhelper.getDesiredParentUK(group[1].uniqueKey, "insideContainer2");
    let nameInputUk = this.lobhelper.getDesiredChildUK(soecialtyParentUk, "nameInput");
    let nameInputRef = this.gmList.gmList[nameInputUk].reference;
    if(CURRENT_TENNANT == 'villagecare'){
      nameInputRef.disabled = false;
      nameInputRef.cdRef.detectChanges();
      if(planRef.data.length > 0){
        if(planRef.data[0] == planRef.options[0].value){
          specialtyRef1.hide = false;
          specialtyRef1.disabled = false;
          specialtyRef2.hide = true;
          specialtyRef3.hide = true;
          specialtyRef4.hide = true;
          this.searchState.Extra.specialtyDD = group[1].name;
          if(specialtyRef2.selected.length > 0){
            specialtyRef2.clearComponent();
          }
          if(specialtyRef3.selected.length > 0){
            specialtyRef3.clearComponent();
          }
          if(specialtyRef4.selected.length > 0){
            specialtyRef4.clearComponent();
          }
        }else if(planRef.data[0] == planRef.options[1].value){
          specialtyRef2.hide = false;
          specialtyRef2.disabled = false;
          specialtyRef1.hide = true;
          specialtyRef3.hide = true;
          specialtyRef4.hide = true;
          this.searchState.Extra.specialtyDD = group[2].name;
          if(specialtyRef1.selected.length > 0){
            specialtyRef1.clearComponent();
          }
          if(specialtyRef3.selected.length > 0){
            specialtyRef3.clearComponent();
          }
          if(specialtyRef4.selected.length > 0){
            specialtyRef4.clearComponent();
          }
        }else if(planRef.data[0] == planRef.options[2].value){
          specialtyRef3.hide = false;
          specialtyRef3.disabled = false;
          specialtyRef1.hide = true;
          specialtyRef2.hide = true;
          specialtyRef4.hide = true;
          this.searchState.Extra.specialtyDD = group[3].name;
          if(specialtyRef1.selected.length > 0){
            specialtyRef1.clearComponent();
          }
          if(specialtyRef2.selected.length > 0){
            specialtyRef2.clearComponent();
          }
          if(specialtyRef4.selected.length > 0){
            specialtyRef4.clearComponent();
          }
        }else if(planRef.data[0] == planRef.options[3].value){
          specialtyRef4.hide = false;
          specialtyRef4.disabled = false;
          specialtyRef1.hide = true;
          specialtyRef2.hide = true;
          specialtyRef3.hide = true;
          this.searchState.Extra.specialtyDD = group[4].name;
          if(specialtyRef1.selected.length > 0){
            specialtyRef1.clearComponent();
          }
          if(specialtyRef2.selected.length > 0){
            specialtyRef2.clearComponent();
          }
          if(specialtyRef3.selected.length > 0){
            specialtyRef3.clearComponent();
          }
        }
      } else {
        nameInputRef.disabled = true;
        nameInputRef.data = undefined;
        nameInputRef.cdRef.detectChanges();
        specialtyRef1.disabled = true;
        specialtyRef1.clearComponent();
        specialtyRef2.disabled = true;
        specialtyRef2.clearComponent();
        specialtyRef3.disabled = true;
        specialtyRef3.clearComponent();
        specialtyRef4.disabled = true;
        specialtyRef4.clearComponent();
      }
    }
    // this.tenantConfigService.getTenantSpecialties({
    //   tenant: CURRENT_TENNANT, ConfiguredPlans: planRef.data[0], 'Accept-Language': localStorage.getItem('translateLanguageTo') || 'en'
    // }).subscribe((res: any) => {
    //    specialtyRef.options = res;
    //    setTimeout(() => {
    //      specialtyRef.cdRef.detectChanges();
    //    })
    //
    // })
  }

  // Function to check if the checkboxes in the slider are checked/
  checkedPreciseLocation(group: any){
    let preciseCheckboxRef = this.gmList.gmList[group[0].uniqueKey].reference;
    let sliderRef = this.gmList.gmList[group[1].uniqueKey].reference;
    let distanceDropRef = this.gmList.gmList[group[2].uniqueKey].reference;
    if(preciseCheckboxRef.checked){
      this.searchState.Query.isPreciseLocation = true;
      sliderRef.disabled = true;
      distanceDropRef.disabled = true;
    }else{
      this.searchState.Query.isPreciseLocation = undefined
      sliderRef.disabled = false;
      distanceDropRef.disabled = false;
    }
  }

  // Handle Primary Care Provider (PCP) checkbox on start page
  checkedPCP(group: any){
    const pcpCheckboxRef = this.gmList.gmList[group[0].uniqueKey]?.reference;
    if (pcpCheckboxRef && typeof pcpCheckboxRef.checked !== 'undefined') {
      const isChecked = pcpCheckboxRef.checked ? true : undefined;
      this.searchState.Query.isPCP = isChecked;
      if (CURRENT_TENNANT === 'champion') {
        const specialtyDropdownRef = this.getActiveSpecialtyDropdownRef(group[0].uniqueKey);
        this.searchState.Query.specialtiesV2 = applyPcpSpecialtySelection({
          isChecked: !!isChecked,
          dropdownRef: specialtyDropdownRef,
          currentValues: Array.isArray(this.searchState.Query.specialtiesV2)
            ? this.searchState.Query.specialtiesV2
            : [],
        });
      }

      this.searchStateService.updateSearchCriteria(this.searchState);
    }
  }

  private getActiveSpecialtyDropdownRef(pcpCheckboxUk: string): any {
    const dropdownIds = [
      'providerOrSpecialityDropdown',
      'providerOrSpecialityDropdown2',
      'providerOrSpecialityDropdown3',
      'providerOrSpecialityDropdown4',
    ];

    const insideContainer2Uk = this.lobhelper.getDesiredParentUK(pcpCheckboxUk, 'insideContainer2');
    const refs = dropdownIds
      .map((id) => {
        try {
          const dropdownUk = insideContainer2Uk ? this.lobhelper.getDesiredChildUK(insideContainer2Uk, id) : undefined;
          return dropdownUk ? this.gmList.gmList[dropdownUk]?.reference : undefined;
        } catch {
          return undefined;
        }
      })
      .filter((ref: any) => !!ref);

    const resolvedRefs =
      refs.length > 0
        ? refs
        : getRefsByJsonId(this.gmList.gmList as any, dropdownIds);
    return getActiveVisibleEnabledRef(resolvedRefs);
  }

  isSearchEnabled(group: any) {
    let isFormValid;
    if(CURRENT_TENNANT == 'villagecare'){
      isFormValid =
        typeof this.searchState.Extra.locationText !== 'undefined' &&
        (
          (typeof this.searchState.Query.name !== 'undefined' && this.searchState.Query.programType &&
            this.searchState.Query.name.trim() !== '' && this.searchState.Query.name.length >= 2) ||
          (Array.isArray(this.searchState.Query.specialtiesV2) &&
            this.searchState.Query.specialtiesV2.length > 0)
        );
    }else if(CURRENT_TENNANT == 'riverspring' || CURRENT_TENNANT == 'elderservehealth'){
      const hasProgramType = Array.isArray(this.searchState.Query.programType) &&
        this.searchState.Query.programType.length > 0 &&
        this.searchState.Query.programType[0] !== '';
      const hasValidName = typeof this.searchState.Query.name !== 'undefined' &&
        this.searchState.Query.name.trim() !== '' && this.searchState.Query.name.length >= 2;
      const hasValidSpecialties = Array.isArray(this.searchState.Query.specialtiesV2) &&
        this.searchState.Query.specialtiesV2.length > 0;

      isFormValid =
        typeof this.searchState.Extra.locationText !== 'undefined' &&
        hasProgramType &&
        (hasValidName || hasValidSpecialties);
    }else if(CURRENT_TENNANT == 'champion'){
      isFormValid =
        typeof this.searchState.Extra.locationText !== 'undefined' &&
        (Array.isArray(this.searchState.Query.planState) &&
          this.searchState.Query.planState.length > 0) &&
        (
          (typeof this.searchState.Query.name !== 'undefined' &&
            this.searchState.Query.name.trim() !== '' && this.searchState.Query.name.length >= 2) ||
          (Array.isArray(this.searchState.Query.specialtiesV2) &&
            this.searchState.Query.specialtiesV2.length > 0)
        );
    }else{
      isFormValid =
        typeof this.searchState.Extra.locationText !== 'undefined' &&
        (
          (typeof this.searchState.Query.name !== 'undefined' &&
            this.searchState.Query.name.trim() !== '' && this.searchState.Query.name.length >= 2) ||
          (Array.isArray(this.searchState.Query.specialtiesV2) &&
            this.searchState.Query.specialtiesV2.length > 0)
        );
    }


    // Safely enable/disable the search button only if the target control exists in the emitted group
    const searchBtnUk = group?.[1]?.uniqueKey;
    const searchBtnRef = searchBtnUk ? this.gmList.gmList[searchBtnUk]?.reference : undefined;

    if (!searchBtnRef) {
      // Some emit groups (e.g., behavioral health filters) may not include the search button.
      // In such cases, simply skip toggling to avoid runtime errors.
      return;
    }

    searchBtnRef.disabled = !isFormValid;
  }

  handleSubmit(group: any) {
    let insideContainer1 = this.lobhelper.getDesiredChildUK(group[1].uniqueKey, "insideContainer1");
    let distanceDropdownUK = this.lobhelper.getDesiredChildUK(insideContainer1, "distanceDropdown");
    let distanceDropdownRef = this.gmList.gmList[distanceDropdownUK].reference;
    this.searchState.Query.location = {
      ...this.searchState.Query.location, // preserve existing keys
      distance: distanceDropdownRef.data?.toString() ?? '25',
    }
    this.searchStateService.updateSearchCriteria(this.searchState);

    //only navigate to search-results after both calls return with a response
    this.loadingSpinnerService.showLoader();
    if(!this.isNLSearchEnabled){
      this.router.navigate(['search-results']);
    } else {
      this.router.navigate(['nls-search-results-v2']);
    }
    this.loadingSpinnerService.hideLoader();
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(this.defaultTitle);
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  // this method to apply the language UI
  private applyPreferredLanguageUI(): void {
    try {
      const selectedId = localStorage.getItem('preferredLanguage') || 'preferredLanguageEnglish';

      const outerUk = this.lobhelper.getDesiredChildUK("0", "careFindrSearchPageOuterContainer");
      const langUk = this.lobhelper.getDesiredChildUK(outerUk, 'careFindrLangResizeContainer');

      const ids = [
        'preferredLanguageEnglish',
        'preferredLanguageCreole',
        'preferredLanguageRussian',
        'preferredLanguageChinese',
        'preferredLanguageSpanish'
      ];

      ids.forEach(id => {
        try {
          const btnUk = this.lobhelper.getDesiredChildUK(langUk, id);
          if (!btnUk) return;

          const btnRef: any = this.gmList.gmList[btnUk]?.reference;
          const btnEl: any = this.gmList.gmList[btnUk]?.elementRef;

          if (!btnRef) return;

          // Update classes
          let classes: string[] = Array.isArray(btnRef.classes)
            ? [...btnRef.classes]
            : (typeof btnRef.classes === 'string' ? btnRef.classes.split(' ').filter(Boolean) : []);

          if (!classes.includes('preferred-language-btn')) {
            classes.push('preferred-language-btn');
          }

          const isActive = id === selectedId;
          if (isActive) {
            if (!classes.includes('active-language')) classes.push('active-language');
            if (btnEl) {
              btnEl.setAttribute('aria-pressed', 'true');
            }
          } else {
            classes = classes.filter(c => c !== 'active-language');
            if (btnEl) {
              btnEl.setAttribute('aria-pressed', 'false');
            }
          }

          btnRef.classes = classes;

        } catch (e) {
          console.warn(`Could not update button ${id}:`, e);
        }
      });
    } catch (error) {
      console.warn('Error applying preferred language UI:', error);
    }
  }

  addToGrandmaster(viewRef: any, data: any) {
    console.log(data)
    this.grandmaster.addChildrenToThisView(viewRef, data);
    // this.firstLoad = false;
  }

  getDataSourceTemplateJson() {
    const partialPromises = [
      this.searchService.registerPartial('recursiveTree', "../../assets/hbs_partials/recursive-tree-partial.hbs")
    ];
    Promise.all(partialPromises).then(() => {
      this.subscriptionData = this.searchService.getCareFindrJson(this.url).subscribe(template => {
        if(localStorage.getItem('largeText') && (localStorage.getItem('largeText') === 'true')){
          const body = document.body;
          this.renderer.addClass(body, 'text-large');
        }
        const compiledTemplate = Handlebars.compile(template); // now a function
        const rendered = compiledTemplate({
          name: 'Search Field',
          locationText: this.searchStateService.getSearchCriteria().Extra.locationText ?? '',
        }); // returns a string
        const response = JSON.parse(rendered);
        this._data = response.componentsConfig;
        this.errorMessages.defaultErrorMessages = response.errorMessages;
        console.log(this.data);

        // Apply initial language selection after a brief delay to ensure DOM is ready
        setTimeout(() => {
          this.applyPreferredLanguageUI();
        }, 50);

        this.loadingSpinnerService.hideLoader();
      });
    }).catch((error) =>{
      console.log("error while loading partials", error)
    });
  }

  private async seedDefaultVillageCareLocation(): Promise<void> {
    if (CURRENT_TENNANT !== 'villagecare') {
      return;
    }

    const currentState = this.searchStateService.getSearchCriteria();
    if (
      currentState.Extra.locationText ||
      currentState.Extra.locationSource === 'user' ||
      currentState.Extra.locationSource === 'cleared'
    ) {
      return;
    }

    try {
      const defaultLocation = await this.defaultLocationService.getVillageCareDefaultLocation();
      this.searchStateService.updateSearchCriteria({
        Query: {
          ...currentState.Query,
          location: {
            ...currentState.Query.location,
            latitude: defaultLocation.latitude,
            longitude: defaultLocation.longitude,
            distance: currentState.Query.location?.distance ?? '100',
          },
        },
        Extra: {
          ...currentState.Extra,
          locationText: defaultLocation.formattedAddress,
          locationSource: 'default',
        },
      });
      this.searchState = this.searchStateService.getSearchCriteria();
    } catch (error) {
      console.warn('Unable to seed default VillageCare location:', error);
    }
  }
}
